<div *transloco="let translate">
    <div class="processAppsMainContainer">
        <div class="processAppsSearchContainer">
            <div class="cssmarqueeCntr" *ngIf="showMarquee && marqueeText && !hideMarqueeMsg">
                <span class="material-icons closeImpMsg" matTooltip="Close" (click)="hideMarqueeMsg = true">close</span>
                <div class="cssmarquee">
                    <h1 [textContent]="marqueeText"></h1>
                </div>
            </div>
            <div class="platformsListContainer">
                <ng-container *ngFor="let ui of uiList">
                    <button matBadge="BETA" [matBadgeHidden]="!ui.beta" class="platformContainer" (click)="setRoute(ui.routeLink)" *ngIf="ui.show" mat-raised-button [title]="ui.displayName">
                        <span [textContent]="ui.displayName"></span>
                    </button>
                </ng-container>
            </div>
            <div class="processAppsSearch" [class.processSearch]="isSearch">
                <mat-form-field class="homePageAppSearch">
                    <input matInput class="processAppsSearchInput" autocomplete="off" [placeholder]="translate('Search Apps')" [(ngModel)]="searchText" (keyup)="checkSearchTextEvent($event)" (focus)="searchFocus($event)" (blur)="searchFocus($event)" />
                    <div class="searchAlign clearSpanDiv" (click)="clearSearch()" *ngIf="searchText && searchText.length > 0" [title]="translate('Clear Search')">
                        <material-button buttonType="icon" [size]="'small'" prefixIcon="close" (buttonClicked)="clearSearch()" [titleText]="translate('Clear Search')"></material-button>
                    </div>
                </mat-form-field>
            </div>
        </div>
        <div *ngIf="!appsToShow || !appsToShow.length">
            <div>
                <ng-container *ngIf="(loadingCall?.subscribedServices !== false && loadingCall?.subscribedServices !== undefined) || loading">
                    <ng-container *ngFor="let count of [1, 2, 3]">
                        <div class="homeProcessesAppContainer">
                            <div class="homeProcessesAppCard shadow-[0_2px_1px_-1px_#0003,0_1px_1px_#00000024,0_1px_3px_#0000001f]">
                                <div class="homeAppProcessesTitle cardTitle isLoading flex items-center justify-between">
                                    <div class="homeAppProcessesTitleText homeAppTitleText loaderBlock isLoading"></div>
                                    <div class="homeAppProcessesLastModified loaderBlock isLoading servicesLoading">
                                        <span [textContent]="translate('Version') + ': |'"></span>
                                        <span [textContent]="translate('Last published') + ':'"></span>
                                    </div>
                                </div>
                                <div class="homeAppProcessesContent mat-card-content">
                                    <div class="homeAppProcessMainContainer">
                                        <div class="workflowStagesContainer loaderBlock isLoading"></div>
                                        <div class="workflowStagesContainer loaderBlock isLoading"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="(!loadingCall.subscribedServices || loadingCall.subscribedServices === false) && !loading && (searchText && searchText.length > 0)">
                    <div class="noRecordMessage" [textContent]="translate('There are no apps matching your search') + '.'"></div>
                </ng-container>
                <ng-container *ngIf="noApps && searchText?.length < 1">
                    <div class="noRecordMessage" [textContent]="translate('You have not subscribed to any app') + '.'"></div>
                </ng-container>
            </div>
        </div>
        <div *ngIf="appsToShow && appsToShow.length">
            <ng-container *ngFor="let app of appsToShow">
                <div class="homeProcessesAppContainer">
                    <div class="homeProcessesAppCard shadow-[0_2px_1px_-1px_#0003,0_1px_1px_#00000024,0_1px_3px_#0000001f]">
                        <div class="homeAppProcessesTitle cardTitle flex items-center justify-between">
                            <div class="flex items-center">
                                <div class="homeAppProcessesTitleText homeAppTitleText font-weight-bold">
                                    <app-display-name [serviceId]="app.serviceId"></app-display-name>
                                </div>
                                <div class="homeAppProcessesNewText homeAppNewText" *ngIf="isAppNew(app)">
                                    <span [textContent]="translate('New')"></span>
                                </div>
                            </div>
                            <div class="homeAppProcessesLastModified loaderBlock" [class.isLoading]="app?.loading?.assetMetaData">
                                <span class="displayInlineBlock" [textContent]="translate('Version') + ':'"></span>
                                <span [textContent]="(app.assetData && app.assetData.version) || ''"></span> |
                                <span class="displayInlineBlock" [textContent]="translate('Last published') + ':'"></span>
                                <span [textContent]="getOriginalLastModifiedDate(app)"></span>
                            </div>
                        </div>
                        <div class="homeAppProcessesContent mat-card-content">
                            <ng-container [ngSwitch]="app.assetType">
                                <ng-container *ngSwitchCase="'BRIDGE_ASSET'">
                                    <bridge-card [bridge]="app" [newProcessInSameTab]="newProcessInSameTab" [allProcessesInSameTab]="allProcessesInSameTab" [processInSameTab]="processInSameTab" [navigateToAppHomeOnly]="navigateToAppHomeOnly" [allReportsInSameTab]="allReportsInSameTab"></bridge-card>
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                    <div class="homeAppProcessMainContainer" AppData [app]="app" (assetDataEmitter)="app.assetData = $event" (requestEmitter)="app.request = $event" (instanceEmitter)="app.instance = $event" (statusEmitter)="app.status = $event" (workflowStagesEmitter)="app.workflowStages = $event" (filingAttributesEmitter)="app.filingAttributes = $event">
                                        <div class="homeAppProcessContainer">
                                            <app-card-container [app]="app" [loading]="app.loading" [newProcessInSameTab]="newProcessInSameTab" [allProcessesInSameTab]="allProcessesInSameTab" [processInSameTab]="processInSameTab" [navigateToAppHomeOnly]="navigateToAppHomeOnly"></app-card-container>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </ng-container>
            <div *ngIf="!isLoadMoreDisable" class="text-center">
                <span (click)="loadMoreApps()" class="cursor-pointer font-bold shadow-md bg-white hover:bg-[#00a651] text-[#00a651] hover:text-white py-2 w-2/4 inline-block text-xs rounded-2xl text-center no-underline" [textContent]="translate('Load More Apps')"></span>
            </div>
        </div>
    </div>
</div>
